export default "__VITE_ASSET__B82c6Qlj__"